import { render, staticRenderFns } from "./StudentExamCard.vue?vue&type=template&id=11a65634&"
import script from "./StudentExamCard.vue?vue&type=script&lang=js&"
export * from "./StudentExamCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports